import { render, staticRenderFns } from "./PreHighLight.vue?vue&type=template&id=397d1420&scoped=true&"
import script from "./PreHighLight.vue?vue&type=script&lang=js&"
export * from "./PreHighLight.vue?vue&type=script&lang=js&"
import style0 from "./PreHighLight.vue?vue&type=style&index=0&id=397d1420&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d1420",
  null
  
)

export default component.exports